import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').Account} Account
 * @typedef {import('../types/system').Subscriptions} Subscriptions
 * @typedef {import('../types/system').Subscription} Subscription
 */

/**
 * @type {function(PlottrState): Account}
 */
export const accountSelector = createSelector(fullSystemStateSelector, ({ account }) => {
  return account ?? {}
})

/**
 * @type {function(PlottrState): Subscriptions}
 */
export const accountSubscriptionsSelector = createSelector(accountSelector, ({ subscriptions }) => {
  return subscriptions ?? {}
})

/**
 * @type {function(PlottrState): Subscription | Null}
 */
export const proAccountSubscriptionSelector = createSelector(
  accountSubscriptionsSelector,
  ({ proSubscription }) => {
    return proSubscription ?? null
  }
)

/**
 * @type {function(PlottrState): Subscription | Null}
 */
export const plottrAccountSubscriptionSelector = createSelector(
  accountSubscriptionsSelector,
  ({ plottrSubscription }) => {
    return plottrSubscription ?? null
  }
)
